// extracted by mini-css-extract-plugin
export default {"wrapper":"SimpleCopyTextButton_wrapper__VNjBm"};